import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

// top level components
import { ActivateComponent } from './containers/activate/activate.component';
import { VersionComponent } from './containers/version/version.component';
import { LoginComponent } from './containers/login/login.component';

// guards
import { AuthGuard } from './guards/auth.guard';
import { NavigationStateGuard } from './guards/navigation-state.guard';
import { CustomerHubModule, customerHubRoutes } from './feature-modules/customer-hub/customer-hub.module';
import { RedirectModule, redirectRoutes } from './feature-modules/redirect/redirect.module';
import { NonProdGuard } from './guards/non-prod.guard';

const routes: Routes = [
  { path: 'login', component: LoginComponent },
  {
    path: 'redirect',
    canActivate: [AuthGuard],
    children: redirectRoutes,
  },
  {
    path: 'customer-hub',
    canActivate: [AuthGuard],
    children: customerHubRoutes,
  },
  {
    path: 'register',
    loadChildren: () => import('./feature-modules/register/register.module').then((m) => m.RegisterModule),
  },
  {
    path: 'refer-a-friend',
    loadChildren: () =>
      import('./feature-modules/refer-a-friend/refer-a-friend.module').then((m) => m.ReferAFriendModule),
  },
  {
    path: 'loginHelp',
    loadChildren: () => import('./feature-modules/login-help/login-help.module').then((m) => m.LoginHelpModule),
  },
  {
    path: 'offers',
    canActivate: [AuthGuard],
    loadChildren: () => import('./feature-modules/offers/offers.module').then((m) => m.OffersModule),
  },
  { path: 'activate', component: ActivateComponent, canActivate: [NavigationStateGuard] },
  { path: 'version', component: VersionComponent },
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  { path: '**', redirectTo: '/login', pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled' }), RedirectModule, CustomerHubModule],
  exports: [RouterModule],
})
export class AppRoutingModule {}
